export class DrawerItem{
  constructor(opts = {}){
    this.key = opts.key
    this.title = opts.title
    if(!this.key || !this.title){
      console.error('DrawerItem: "title" or "key" is required')
    }
    this.icon = opts.icon
    this.to = opts.to
    this.href = opts.href
    this.subitems = opts.subitems || []
    this.parent = opts.parent
  }
  get fullkey(){
    return `${this.parent ? this.parent.key : ''}/${this.key}`
  }
  matchKey(key){
    if(this.key === key){
      return true
    }
    // 若 key 為 abc/def
    // 則可 match 到該 subitem
    if(this.subitems.length > 0){
      let p = key.indexOf(`${this.key}/`)
      if(p > -1){
        let subItemKey = this.key.substring(p)
        for(let item of this.subitems){
          if(item.key === subItemKey){
            return true
          }
        }
      }
    }
    return false
  }
  toJSON(){
    let obj = { ...this }
    delete obj.parent
    return obj
  }
}
export default DrawerItem
